import { TimerOutlined } from '@mui/icons-material'

const WhatToDoNextCards = ({ count, title, timingButton, appStore, description, lengthCards, image, icon }) => {
    return (
        <div className={`${lengthCards === 2 ? 'ml0-5rem' : 'ml1-5rem'}`} style={{ maxWidth: '150px' }}>
            <div className={`pr bg1 br10px df aisb fdc jcsb  w100 `} style={{ height: '210px', width: '100%', }}>

                {count && <div className='pa p0-5rem c1 df aic jcc' style={{ top: '-18px', left: '50%', height: '32px', width: '32px', transform: 'translateX(-50%)', background: '#4A67FF', borderRadius: '50px' }}>
                    {count}
                </div>}
                <div className='w100'>{title}</div>
                {image && <img src={image} alt='image' width={96} height={76} className='ml1rem' />}
                {icon && <img src={icon} alt='icon' width={60} height={60} className='ml1rem' />}
                {
                    appStore && <div className='pl1rem'>
                        <img style={{ width: '80px' }} src={require('../../../../images/whatYouGetModal/appStoreIcon.png')} alt='appStoreIcon' />
                        <p className='c15 fs9px op60'>(Additional purchase required)</p>
                    </div>
                }

                {timingButton && <div className='bg4 df aic fs12px ml1rem mb0-5rem fw600' style={{ color: '#101F68', background: '#FC7785', borderRadius: '20px', padding: '4px 4px', width: '84px', }}>
                    <TimerOutlined className='ml0-5rem' style={{ color: '#101F68', marginRight: '4px', maxWidth: '18px' }} />
                    {timingButton}
                </div>}

            </div>

            {description && <p className='c15 tac fs11px ml0rem mt2rem' style={{ height: '50px', width: '100%' }}>{description}</p>}
        </div>
    )
}

export default WhatToDoNextCards